import { useApp } from '../store.ts';

export function Toast() {
  const toast = useApp((s) => s.toast);
  if (!toast) return null;
  return (
    <div className={`toast${toast.error ? ' error' : ''}`} role="status" aria-live="polite">
      <span className="ellipsis" title={toast.text}>
        {toast.text}
      </span>
    </div>
  );
}
